import React from 'react';
import { StudyParticipantImage } from '../models/StudyParticipantImage';
import { Dimensions, Modal, ModalProps, Image, Platform } from 'react-native';
import { useStudyContext } from '../context/StudyContext';
import styled from 'styled-components/native';
import IconButton from './IconButton';
import { B, P } from './Typography';
import { Feather } from '@expo/vector-icons';
import { format, differenceInDays } from 'date-fns';

const StyledToolbarView = styled.View`
  height: ${Platform.OS === 'web' ? 64 : 96}px;
  align-items: center;
  justify-content: center;
`;

const StyledCloseIconButton = styled(IconButton)`
  position: absolute;
  top: ${Platform.OS === 'web' ? 20 : 52}px;
  left: 20px;
  z-index: 1;
`;

const StyledScrollView = styled.ScrollView`
  flex: 1;
`;

const StyledImageCompareView = styled.View`
  width: 100%;
  height: 100%;
  padding: 16px;
  justify-content: center;
  flex-direction: row;
`;

const StyledImageView = styled.View`
  align-items: center;
`;

const StyledImage = styled(Image)`
  margin-bottom: 8px;
`;

const StyledTitle = styled(B)`
  margin-top: ${Platform.OS === 'ios' ? 42 : 16}px;
  text-align: center;
`;

const StyledP = styled(P)`
  font-size: 18px;
  line-height: 29px;
`;

const ImageCompareModal: React.FC<
  ModalProps & { images: StudyParticipantImage[] }
> = ({ images, ...props }) => {
  const { onRequestClose } = props;
  const { studyParticipant } = useStudyContext();
  const columnCount = 2;
  const cellPadding = 2;
  const screenWidth = Dimensions.get('window').width - 32;
  const tileSize = screenWidth / columnCount - cellPadding * columnCount;

  return (
    <Modal animationType='slide' {...props}>
      <StyledToolbarView>
        <StyledTitle>Compare</StyledTitle>
        <StyledCloseIconButton onPress={onRequestClose}>
          <Feather name='arrow-left' size={28} color='black' />
        </StyledCloseIconButton>
      </StyledToolbarView>
      <StyledScrollView>
        <StyledImageCompareView>
          <StyledImageView>
            <StyledImage
              source={{ uri: images[0].smallUrl }}
              resizeMode='cover'
              style={{ width: tileSize, height: tileSize, marginRight: 2 }}
            />
            {studyParticipant?.startDate && (
              <>
                <StyledP center color='dark'>
                  {format(images[0].created, 'MMM d, yyyy')}
                </StyledP>
                <StyledP color='dark'>
                  Day{' '}
                  {differenceInDays(
                    images[0].created.setHours(0, 0, 0),
                    studyParticipant?.startDate?.setHours(0, 0, 0)
                  ) + 1}
                </StyledP>
              </>
            )}
          </StyledImageView>
          <StyledImageView>
            <StyledImage
              source={{ uri: images[1].smallUrl }}
              resizeMode='cover'
              style={{ width: tileSize, height: tileSize, marginLeft: 2 }}
            />
            {studyParticipant?.startDate && (
              <>
                <StyledP center color='dark'>
                  {format(images[1].created, 'MMM d, yyyy')}
                </StyledP>
                <StyledP color='dark'>
                  Day{' '}
                  {differenceInDays(
                    images[1].created.setHours(0, 0, 0),
                    studyParticipant?.startDate?.setHours(0, 0, 0)
                  ) + 1}
                </StyledP>
              </>
            )}
          </StyledImageView>
        </StyledImageCompareView>
      </StyledScrollView>
    </Modal>
  );
};

export default ImageCompareModal;
